import React from 'react';
import injectSheet from 'react-jss';

import img from './user.jpg';

const styles = {
  card: {
    display: 'flex',
    minWidth: '50%',
    margin: [35, 0],
  },
  bigCard: {
    display: 'flex',
    minWidth: '100%',
  },
  img: {
    width: 86,
    height: 86,
    marginRight: 15,
  },
  bigImg: {
    width: 170,
    height: 179,
    marginRight: 35,
  },
  name: {
    textTransform: 'uppercase',
    fontWeight: 'bold',
    fontSize: 20,
  },
  title: {
    color: 'rgb(237, 9, 37)',
    fontSize: '0.8em',
  },
  phone: {
    marginTop: '0.7em',
    fontSize: '0.8em',
  },
  email: {
    fontSize: '0.8em',
  }

}

const ContactCard = injectSheet(styles)(({classes, isBig, name, title, phone, email}) => (
  <div className={classes[isBig ? 'bigCard' : 'card']}>
    <img src={img} className={classes[isBig ? 'bigImg' : 'img']}/>
    <div className={classes.data}>
      <div className={classes.name}>{name}</div>
      {title && <div className={classes.title}>{title}</div>}
      <div className={classes.phone}>
        Puhelin: <a href={`tel: ${phone}`}>{phone}</a>
      </div>
      <div className={classes.email}>
        Sähköposti: <a href={`mailto: ${email}`}>{email}</a>
      </div>
    </div>
  </div>
));

export default ContactCard;



// WEBPACK FOOTER //
// ./src/components/ContactCard/ContactCard.js